const DEFAULT_HIGHCHART_CONFIG: Partial<Highcharts.Options> = {
    chart: {
        style: {
            fontFamily: "'Lato', sans-serif",
            backgroundColor: "#ffffff"
        }
    },
    title: {
        style: {
            color: "#2f3452",
            fontWeight: "normal"
        }
    },
    subtitle: {
        style: {
            color: "#6b7280"
        }
    },
    legend: {
        align: "center",
        verticalAlign: "bottom",
        itemStyle: {
            color: "#2f3452",
            fontWeight: "normal"
        },
        itemHoverStyle: {
            color: "#2f3452"
        }
    },
    tooltip: {
        enabled: true,
        shared: true,
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        borderWidth: 1,
        borderRadius: 4,
        shadow: true,
        hideDelay: 0,
        style: {
            color: "#2f3452",
            fontSize: "13px"
        }
    },
    plotOptions: {
        series: {
            animation: true,
            enableMouseTracking: true
        }
    },
    exporting: {
        enabled: true,
        buttons: {
            contextButton: {
                menuItems: [
                    "viewFullscreen",
                    "separator",
                    "downloadPNG",
                    "downloadJPEG",
                    "downloadSVG",
                    "downloadPDF"
                ]
            }
        }
    },
    credits: {
        enabled: false
    }
};

export default DEFAULT_HIGHCHART_CONFIG;
